import React from 'react';
import { ORIGINAL_ESTIMATE } from '../../../../model/constants';
import { useBacklogSelector } from '../../../../state';
import { getEstimationType } from '../../../../state/selectors/estimation';
import OriginalEstimateFieldStatic from '../../card/card-contents/original-estimate-field/original-estimate-field-static';

export const EstimateLite = ({
	shouldRenderEstimatesColumn,
}: {
	shouldRenderEstimatesColumn: boolean;
}) => {
	const estimationType = useBacklogSelector(getEstimationType);
	if (estimationType !== ORIGINAL_ESTIMATE) return null;

	return (
		<OriginalEstimateFieldStatic hasEstimate={shouldRenderEstimatesColumn} value={undefined} />
	);
};
